export default "__VITE_ASSET__QJZU$Kvb__"